import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.fbq) return;
  const fbq: any = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  w.fbq = fbq;
  if (!w._fbq) w._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
  w.fbq('init', '2054642012133298');
  w.fbq('track', 'PageView');
})();
// Noscript fallback
if (typeof document !== 'undefined') {
  const noscript = document.createElement('noscript');
  noscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2054642012133298&ev=PageView&noscript=1" />';
  document.body ? document.body.appendChild(noscript) : document.addEventListener('DOMContentLoaded', () => document.body.appendChild(noscript));
}
render(<App data-id="element-189" />, document.getElementById('root'));